"use client";

import { ISearchCatNavBannersResponse } from "@faire/web-api/indigofair/data/ISearchCatNavBannersResponse";
import React, { createContext, ReactNode, useContext } from "react";

import { useKeyValueCache } from "@faire/retailer/lib/useKeyValueCache";

const RawBannerDataContext = createContext<
  ISearchCatNavBannersResponse | undefined
>(undefined);

export const RawBannerDataProvider = ({
  children,
  rawBannerData,
  cacheKey,
}: {
  children: ReactNode;
  rawBannerData: ISearchCatNavBannersResponse | undefined | "CACHE_HIT";
  cacheKey: string;
}) => {
  const lastCachedData = useKeyValueCache(rawBannerData, cacheKey);

  return (
    <RawBannerDataContext.Provider value={lastCachedData}>
      {children}
    </RawBannerDataContext.Provider>
  );
};

export const useRawBannerData = () => {
  return useContext(RawBannerDataContext);
};
